import React from 'react';
import mergeStyles from '@alucio/lux-ui/src/components/util/mergeStyles';
import Box from '@alucio/lux-ui/src/components/layout/Box/Box';
import responsive from '@alucio/lux-ui/src/components/responsive';
export const DEFAULT_OFFSET = 8;
export const DEFAULT_TYPE = 'tooltip';
export const S = {
    content: {
        tooltip: {
            justifyContent: 'center',
            borderRadius: 4,
            paddingLeft: 8,
            paddingRight: 8,
            paddingTop: 4,
            paddingBottom: 4,
            backgroundColor: '#2C3651',
            borderColor: '#2C3651',
        },
        menu: {},
    },
};
export const Content = (props) => {
    const { children } = props;
    return children;
};
export const Anchor = (props) => {
    const { children, style } = props;
    return (<Box style={style}>
      {children}
    </Box>);
};
Content.defaultProps = {
    offset: DEFAULT_OFFSET,
};
Content.calculateStyle = (props, contentProps) => mergeStyles(props, S.content[props.type || 'menu'], [{ marginVertical: contentProps.offset }, !responsive.device.isWeb]);
Content.displayName = 'Content';
Anchor.displayName = 'Anchor';
export default {
    S,
    Content,
    Anchor,
    DEFAULT_OFFSET,
};
// TODO: Support Menu Popover (most likely through a modal)
// TODO: Mobile Parity
//# sourceMappingURL=PopoverCore.js.map